import { Value } from 'app/types-shared';
import { AccessPerson, ExtraInfoCodeValues, UserOptions } from 'app/components/access-panel/shared/types';
import {
  DateRangeObject, DecimalRangeObject, FilterSearchModel, RangeObject, SelectedIdsObject
} from 'app/area/search-filters/types-store';
import { DefaultRole } from 'app/area/administration/shared/types';
import { MergeUserState } from 'app/area/administration/shared/merge-user/types-store';
import { ValidationProps } from 'ui';

export enum SearchArea {
  none = 'none',
  user = 'user',
  role = 'role'
}
export interface AdministrationSearchState {
  results: SearchResults;
  requestedSearchModel: FilterSearchModel;
  textsFetching?: boolean;
  exportUserExcelFetching?: boolean;
  exportRoleExcelFetching?: boolean;
  texts?: any;
  fetchingDefaultRole: boolean;
  defaultRole: DefaultRole;
  isSettingDefaultRole: boolean;
  settingDefaultRoleId?: number;
  extraInfoCodes: ExtraInfoCodeValues[];
  fetchingExtraInfoCodes: boolean;
  hasRoles: boolean;
  fetchingRoles: boolean;

  mergeUser?: MergeUserState;
  userOptions?: UserOptions;
  validation: { [key: string]: ValidationProps };
}

export interface ItemPersonAccess {
  access?: AccessPerson;
  fetching: boolean;
}

export interface SearchResults {
  fetching: boolean;
  list: SearchData[];
  itemPersonAccess?: ItemPersonAccess;
  total: number;
  requestId: number;
}

export interface SearchData {
  id: number;
  personId: string;
  name: string;
  emailAddress: string;
  mainUserGroup: string;
  role: Value;
  isDefault?: boolean;

  deleted?: boolean;
  technical: boolean;
  disabled?: string;
}

export interface ExtraInfoObject {
  additionalInformation: number;
  string?: RangeObject;
  integer?: RangeObject;
  code?: SelectedIdsObject;
  date?: DateRangeObject;
  float?: DecimalRangeObject;
}
